const initialValues = {
  name: '',
  description: '',
};

export default initialValues;
